import { z } from 'zod';
import {
  PackageStatusDetailsLevelEnum,
  PackageStatusDetailsStatusEnum,
} from '../domain';

export const packageStatus = z
  .string()
  .trim()
  .toUpperCase()
  .transform((status) => PackageStatusDetailsStatusEnum?.[status] || null);

export const packageLevel = z
  .string()
  .trim()
  .toUpperCase()
  .transform((level) => PackageStatusDetailsLevelEnum?.[level] || null);
